import React from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import './LocationFull.css'; // Importing the CSS file
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

function LocationFull() {
  const position = [55.740596, -3.336971];
  let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;

  return (
    <>
    <div className="container">
      <div className="text-section">
        <div className="directions">
        <h2 className='title'>How to Find Us</h2>
        <h3>Arriving by Car from the South</h3>
        <p>Arriving by car from the south: take M6/M74 Junction 13, Abington, (signposted Edinburgh). After 23 miles you will arrive in West Linton. Turn right into the village and drive through, bearing left on the B7059 for approx. 1 mile. Balgonie Retreat is situated next on the right after Broomlee Centre.</p>
        
        <h3>Scenic Route from the South</h3>
        <p>For a slightly longer, more scenic route: take M6/M74 Junction 15, Moffat, A701 North. After 33 miles you will go through Romanno Bridge. Just after, take the B7059 left sign posted West Linton for 1.5 miles and Balgonie Retreat is situated on the left-hand side.</p>

        <h3>Arriving by Car from the North</h3>
        <p>Arriving by car from the north: take the Edinburgh City Bypass A720 to Lothianburn Junction, signposted A702, Biggar and Carlisle. After 12 miles you will arrive in West Linton. Turn left into the village and drive through, bearing left on the B7059 for approx. 1 mile. Balgonie Retreat is situated next on the right after Broomlee Centre.</p>
        </div>
      </div>
      <div className="map-section">
      <iframe className="gmapIframe" width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Balgonie,%20West%20Linton+(Balgonie%20Retreat)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/">gps vehicle tracker</a></iframe>
      </div>
    </div>
    </>
  );
}

export default LocationFull;
